export default __webpack_public_path__ + "static/media/indexxAdvocacy.2c6ca9a3.png";